import { usePlatformStatCells } from '@/features/home/usePlatformStatCells'
import styles from './ProofStrip.module.css'

/**
 * Home proof strip — a thin band of credibility facts under the hero. Four
 * tiles (courts, tournaments run, rated players, matches played), live from
 * the shared platform-stats selector; on loading it shows skeleton pills
 * (height-reserving → CLS=0), and on error OR any one count still at zero it
 * falls back to the static facts — never a blank, zero, or invented count, and
 * never a mix of real and blank tiles. docs/ux/2026-09-23-platform-counters.md.
 */
export function ProofStrip() {
  const cells = usePlatformStatCells()
  const loading = cells[0]?.kind === 'loading'

  return (
    <section
      className={styles.strip}
      aria-label="Platform at a glance"
      aria-hidden={loading || undefined}
      data-track-section
      data-track-wake
      data-enter="pop"
    >
      {cells.map((cell) => {
        if (cell.kind === 'loading') {
          return (
            <div key={cell.label} className={styles.pill}>
              <span className={styles.skeleton} />
            </div>
          )
        }
        if (cell.kind === 'value') {
          return (
            <div key={cell.label} className={styles.pill}>
              <span className={styles.value} data-count={cell.value}>
                {cell.value.toLocaleString()}
              </span>
              <span className={styles.caption}>{cell.label}</span>
            </div>
          )
        }
        return (
          <div key={cell.text} className={`${styles.pill} ${styles.pillStatic}`}>
            <span className={styles.phrase}>{cell.text}</span>
          </div>
        )
      })}
    </section>
  )
}
